// @flow

import * as React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useAnalytics } from '../../controls/analytics';
import { useRouter } from '../../controls/router';
import type { AggregatesListingAnalytics_listing$key } from './__generated__/AggregatesListingAnalytics_listing.graphql';

type Props = {|
  listing: ?AggregatesListingAnalytics_listing$key,
|};

export const AggregatesListingAnalytics: React.AbstractComponent<Props, mixed> =
  React.memo(props => {
    const listing = useFragment(
      graphql`
        fragment AggregatesListingAnalytics_listing on AggregatesListing {
          id
          encodedId
          slug
          offerType
          propertyType
          compositePropertyType
          numberOfRooms
          numberOfBathrooms
          livingSurface
          landSurface
          salePrice
          grossRentMonthly
          currency
          constructionYear
          locality
          propertyMainType
          stateObject {
            label
          }
          municipalityObject {
            label
          }
          streetNumber
          route
          postcode
          lat
          lng
          agencyName
          agencyReference
          lotReference
        }
      `,
      props.listing,
    );

    const { track } = useAnalytics();
    const router = useRouter();

    const properties = {
      id: listing?.id,
      encodedId: listing?.encodedId,
      slug: listing?.slug,
      offerType: listing?.offerType,
      propertyType: listing?.propertyType,
      propertyMainType: listing?.propertyMainType,
      compositePropertyType: listing?.compositePropertyType,
      numberOfRooms: listing?.numberOfRooms,
      numberOfBathrooms: listing?.numberOfBathrooms,
      livingSurface: listing?.livingSurface,
      landSurface: listing?.landSurface,
      salePrice: listing?.salePrice,
      grossRentMonthly: listing?.grossRentMonthly,
      currency: listing?.currency,
      constructionYear: listing?.constructionYear,
      locality: listing?.locality,
      state: listing?.stateObject?.label,
      municipality: listing?.municipalityObject?.label,
      streetNumber: listing?.streetNumber,
      route: listing?.route,
      postcode: listing?.postcode,
      lat: listing?.lat,
      lng: listing?.lng,
      agencyName: listing?.agencyName,
      agencyReference: listing?.agencyReference,
      lotReference: listing?.lotReference,
      url: router.asPath,
      nonInteraction: 1,
    };

    React.useEffect(() => {
      track('RA.Web.Listing.Viewed', properties);
    });

    return null;
  });
